// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"8b1d2ebd","32":"090759c7","73":"f6135011","328":"d156915d","344":"6ec4761e","490":"27f00fb9","648":"8cc1c22e","804":"90699385","920":"dd20dbe7"}[chunkId] + ".chunk.js";
};